<script>
	import { onMount } from "svelte";
	import { elasticOut } from "svelte/easing";
	import { fade } from "svelte/transition";
	import { onDestroy } from "svelte";
	import { springIn, springOut } from "svelte-helpers/spring-transitions";
	import Header from "./Header.svelte";
	import Switch from './Switch.svelte';
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
	import { replace, push } from 'svelte-spa-router'

	const progress = tweened(0, {
		duration: 200,
		easing: cubicOut
	});

	const progress_factor = tweened(0, {
		duration: 400,
		easing: cubicOut
	});

	let recharge_mebot_url = '';
	import { writable } from 'svelte/store';
	import Modal, { bind } from 'svelte-simple-modal';
	import RechargeMebot from './RechargeMebot.svelte';
	import UnhatchedMebot from './UnhatchedMebot.svelte';
	import PopupMebot from './PopupMebot.svelte';
	const modal = writable(null);

	import { sparkle_img } from './SparkleImg.svelte'

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

	// The params prop contains values matched from the URL
	export let params = {};

	let zombie_eaten = false;
	let flip_box_border = 'flip_box_border1';
	let flip_box_front = 'flip-box-front1';
	let audio;
	let boost_audio;
	let selected;
	let selected_id;
	let selected_set = [];
	let selected_rare_set = [];
	let selected_set_tmp = [];
	let last_symbol_id = -1;
	let tapped = 0;
	let tapped_max = 20;
	let tapped_i = -1;
	let last_tapped_i = -1;
	let game_size = 289;
	let game_row_size = 17;
//	let game_size = 10000;
//	let game_row_size = 100;
	let game_size_active = 81;
	let game_row_size_active = 9;
	let found_rare = 0;
	let rare_symbol = "";
	let collected_n = 0;
	let collected_str = "";
	let collected_rare_str = "";
	let game_play_time = 45;
	let play_time = game_play_time;
	let time_remaining = play_time;
	let original_play_time = play_time;
	let extra_time = 0;
	let start_time = Math.floor(Date.now() / 1000);
	let cur_time = Math.floor(Date.now() / 1000);
	let _number_of_mebots = 12;
	let sparkle_count = 0;
	let is_rebuilding = 0;
	let border_id = 1;
	let owner_id = -1;
	let speed_factor = 1;
	let nominal_speed_factor = 0;
	let bolts_collected = 0;
	let watts_level = 0;
	let autopilot_level = 0;
	let watts_count = 0;
	let watts_calc = 0;
	let auto_targets = [];
	let timeout_id;
	let watts_e = false;
	let other_m_delay = 0;
	//console.log(cur_time);
	//$:console.log(selected)

	let landTiles = [];
	let landTilesFinal = [];
	let border = 0;
	let prize = 0;

	let mebots = [];
	let mebots_moving = true;
	let mebot_pos = [];
	let calculated_pos = [];
	let last_mebot_pos = [];
	let last_mebot_dir = [];
	let next_mebot_pos = [];
	let boosts_left = [];
	let dir = [];
	let dirs = [];
	let x_offset = 0;
	let y_offset = 0;
	let target_tile = 0;
	let target_tile_x = 0; let target_tile_y = 0; let owner_x = 0; let owner_y = 0;
	let row = 0;
	let last_tap = -1;
	let current_tap = -1;
	let prize_n = 0;
	let minimum_steps = 0;
	let steps_remaining = minimum_steps;
	let steps_taken = 0;
	let large_sparkle_img = '/img/sparkle-200-large.png';
	let mebot_winner_img_url = [];
	let mebot_winner_score = [];
	let mebot_winner_id = [];
	let _default_delay = 220;
	let delay = _default_delay;
	let boost_left = 0;
	let clocks_n = 0;
	let zombies_n = 0;
	let zombie_prev = 0;
	let wormhole_n = 0;
	let watts_n = 0;
	let steps_took = 0;
	let is_flashing = false;
	let is_sparkle_flash = false;
	let auto_roam = false;
	$: auto_roam, saveAutopilot();

	let auto_assigned = false;
	let show_close = true;
	let progress_n = 20;

	load_game()

	async function restartGame() {
		auto_targets = [];
		border_id = 1;
		flip_box_border = 'flip_box_border' + border_id%5;
		flip_box_front = 'flip-box-front' + border_id%5;
		selected_set = [];
		selected_rare_set = [];
		selected_set_tmp = [];
		last_symbol_id = -1;
		tapped = 0;
		tapped_max = 20;
		tapped_i = -1;
		last_tapped_i = -1;
		game_size = 225;
		game_row_size = 15;
		game_size_active = 81;
		game_row_size_active = 9;
		found_rare = 0;
		rare_symbol = "";
		collected_n = 0;
		collected_str = "";
		collected_rare_str = "";
		play_time = game_play_time;
		time_remaining = play_time;
		extra_time = 0;
		start_time = Math.floor(Date.now() / 1000);
		cur_time = Math.floor(Date.now() / 1000);
		landTiles = [];
		landTilesFinal = [];
		border = 0;
		prize = 0;
		mebots = [];
		mebots_moving = true;
		mebot_pos = [];
		last_mebot_pos = [];
		last_mebot_dir = [];
		next_mebot_pos = [];
		dir = [];
		x_offset = 0;
		y_offset = 0;
		target_tile = 0;
		target_tile_x = 0; let target_tile_y = 0; let owner_x = 0; let owner_y = 0;
		row = 0;
		last_tap = -1;
		current_tap = -1;
		prize_n = 0;
		sparkle_count = 0;
		clocks_n = 0;
		zombies_n = 0;
		wormhole_n = 0;
		watts_n = 0;
		owner_id = -1;
		speed_factor = 1;
		bolts_collected = 0;
		load_game()
		await fetchActiveMebots();
		update_board()
		delay = _default_delay;
		boost_left = 0;
		boosts_left = [];
		mebot_winner_img_url = [];
		mebot_winner_score = [];
		mebot_winner_id = [];
		steps_taken = 0;
	}

	async function reloadBoard() {
		is_rebuilding = 1;
		border_id++;
		if (border_id > 4) {
			border_id = 1;
		}
		flip_box_border = 'flip_box_border' + border_id%5;
		flip_box_front = 'flip-box-front' + border_id%5;
		if (border_id == 2) {
			//flip_box_border = 'text-electric-wormhole2';
		}
		selected_set = [];
		selected_rare_set = [];
		selected_set_tmp = [];
		last_symbol_id = -1;
		tapped = 0;
		tapped_max = 20;
		tapped_i = -1;
		last_tapped_i = -1;
		found_rare = 0;
		rare_symbol = "";
		collected_n = 0;
		collected_str = "";
		collected_rare_str = "";
		landTiles = [];
		landTilesFinal = [];
		border = 0;
		prize = 0;
		mebots_moving = true;
		target_tile = 0;
		target_tile_x = 0; let target_tile_y = 0; let owner_x = 0; let owner_y = 0;
		row = 0;
		last_tap = -1;
		current_tap = -1;
		sparkle_count = 0;
		clocks_n = 0;
		zombies_n = 0;
		wormhole_n = 0;
		watts_n = 0;
		auto_targets = [];
		load_game()
		delay = _default_delay;
		await sleep(600);

		for (let i = 1; i <= _number_of_mebots; ++i) {
			if (mebots[i-1].is_owner == 1) {
				if (landTiles[mebot_pos[i]].s == -1) {
					sparkle_count--;
					mebots[i-1].prize_n++;
					prize_n = mebots[i-1].prize_n;
					is_sparkle_flash = true;
				}
				landTiles[mebot_pos[i]].s = i;
				dirs[i] = []
			}
		}
		is_rebuilding = 0;

		if (auto_targets.length > 0 && auto_targets.length > autopilot_level) {
			//console.log('limiting ' + auto_targets)
			if (autopilot_level-2 <= 0) {
				auto_targets = []
			} else {
				auto_targets.slice(0, autopilot_level*2-2)
			}
			//console.log('to: ' + auto_targets)
		}

	}

	function load_game() {
		let found_tile = 0;
		for (let i = 0; i < game_size; i++) {
		prize = 0;
		found_tile = 0;
		if (i%game_row_size == 0 || i%game_row_size == (game_row_size-1) || i < game_row_size || i >= game_size-game_row_size) {
			border = 1;
			found_tile = - 1;
		} else {
			border = 0;

			if (i != (1 * game_row_size + 1)) {

			if (Math.floor(Math.random() * (Math.floor(Math.random() * 4 + 1)) + 1) == 2) {
				prize = -1;
				sparkle_count++;
			}
			//bolt
			if (Math.floor(Math.random() * 60 + 1) == 2) {
				if (prize == -1) {
					sparkle_count--;
				}
				prize = -2;
				auto_targets = [...auto_targets, i]
			}
			//extra time
			if (Math.floor(Math.random() * 40 + 1) == 2 && clocks_n < 4) {
				if (prize == -1) {
					sparkle_count--;
				}
				prize = -3;
				clocks_n++;
				//if (clocks_n <= 3) {
					auto_targets = [...auto_targets, i]
				//}
			}
			//zombie
			if (Math.abs(i-zombie_prev) > 2 && (Math.abs(i-zombie_prev))%game_row_size != 0) {
				if (Math.floor(Math.random() * 50 + 1) == 3 && zombies_n < 10) {
					if (prize == -1) {
						sparkle_count--;
					}
					prize = -4;
					zombies_n++;
					zombie_prev = i;
					auto_targets = auto_targets.filter(item => item !== i)
				}
			}
			//wormhole
			if (Math.abs(i-zombie_prev) > 2 && (Math.abs(i-zombie_prev))%game_row_size != 0) {
				//if (Math.floor(Math.random() * 1 + 1) == 1 && wormhole_n < 200) {
				if (Math.floor(Math.random() * 1000 + 1) == 2 && wormhole_n < 1) {
					if (prize == -1) {
						sparkle_count--;
					}
					prize = -5;
					wormhole_n++;
					zombie_prev = i;
					auto_targets = auto_targets.filter(item => item !== i)
				}
			}

			if (watts_e && watts_n < 1 && Math.floor(Math.random() * 2000 + 1) == 3) {
				if (prize == -1) {
					sparkle_count--;
				}
				prize = -6;
				watts_n++;
			}

			}
		}
		landTiles.push({
			id: i,
			name: "",
			watts: "56",
			watt_level: "4",
			img: "/img/mebots-watts.png",
			s: prize,
			text: "",
			rarity: 0,
			found: found_tile,
			b: border
			//text: '𒈙',
		});
	}
	//console.log(auto_targets)

	}

	function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
	}

	function update_board() {
		let landTilesFinal_tmp = [];
		for (let i = 0; i < game_row_size_active; i++) {
			landTilesFinal_tmp.push(...landTiles.slice(y_offset*game_row_size + x_offset + game_row_size*i, y_offset*game_row_size + x_offset +  game_row_size*i + game_row_size_active));
		}
		landTilesFinal = landTilesFinal_tmp;
		//console.log(landTilesFinal)
	}
	update_board()

	function displayRechargeMessage() {
		clearTimeout(timeout_id);
		show_close = false
		modal.set(bind(RechargeMebot, { mebot_img_url: recharge_mebot_url }));
		timeout_id = setTimeout(function(){ modal.set(null); }, 5000);

		cur_time = Math.floor(Date.now() / 1000);
		time_remaining = play_time - cur_time + start_time;
		if (time_remaining > 5) {
			play_time = 5 + cur_time - start_time;
		}
		progress.set(0)
	}

	const onGetAppAction = () => {

		setCookie("v_h_id", -3, 1)
		replace("/dash/2/1");
    };

	async function displayUnhatchedMessage() {

		let is_anon = getCookie("is_anon");

		if (is_anon == 1) {
			displayMebotMessage(`
			<center>
			<br><br>
			Download Steps app to play this game 👇 <br><br>
			</center>`, 10000, 'Get app', onGetAppAction)
		} else {
	
		clearTimeout(timeout_id);
		show_close = false
		modal.set(bind(UnhatchedMebot, { mebot_img_url: recharge_mebot_url }));
		timeout_id = setTimeout(function(){ modal.set(null); }, 20000);

		}

		cur_time = Math.floor(Date.now() / 1000);
		time_remaining = play_time - cur_time + start_time;
		if (time_remaining > 3) {
			play_time = 3 + cur_time - start_time;
		}
		time_remaining = play_time - cur_time + start_time;
		await sleep(1000);
		time_remaining = 3;
		await sleep(1000);
		time_remaining = 2;
		await sleep(1000);
		time_remaining = 1;
		await sleep(1000);
		time_remaining = 0;

		await sleep(310);
		setWinners();
	}

	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		let is_show_close = true
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

	function displayZombieMessage() {
		show_close = false
		displayMebotMessage('Zombies 🧟🧟‍♀️🧟‍♂️ <br> snatched your Mebot! 😱', 3000)
		progress_factor.set(0)

		cur_time = Math.floor(Date.now() / 1000);
		time_remaining = play_time - cur_time + start_time;
		if (time_remaining > 3) {
			play_time = 3 + cur_time - start_time;
		}
		//displayMebotMessage('Your Mebot was eaten by<br> 🧟🧟‍♀️🧟‍♂️ ', 3000)
	}

	function displayFoundEgg() {
		show_close = true

		displayMebotMessage(`
		<center>
			<br><br>
			<b>Congrats!!!</b><br><br><br>
		<img src='/img/egg-winner1.png' width='300px' height='215px' alt='Congratulations'/><br><br>

		You discovered Mebot Egg!<br><br> 🏆 🥳 🎉<br><br>
		Go to your dashboard<br>
		to claim & hatch it!
		<br><br>
		<br><br>
		</center>`, 10000)

		saveGame(true)
		//		<a href="/#/dash/"><button>Hatch</button></a>
	}

	function displaySpeedFactorInfo() {
		show_close = false
		displayMebotMessage('<br><b>Your Mebot Speed Factor</b> <br><br><br> <b>' +  Number(watts_count) + ' Watts</b> ⚡<br> + <br> (Watt Level <b>' +  Number(watts_level) + '</b>)✖️10 = <b>' +  Number(watts_level*10) + ' Watts</b> ⚡<br><br>👇<br><br> Speed factor: <b>' + watts_calc + ' Watts</b> ⚡<br><br>', 5000)
	}

	function displayStepsInfo() {
		displayMebotMessage('<br><br> You have 👟 ' + numberWithCommas(steps_remaining) + ' steps left in your balance. <br><br><br>', 5000)
	}

	function displayAutopilot() {
		displayMebotMessage(`
		<center>
			<br><br>
		<b>Your Mebot Autopilot Level: ` + autopilot_level  + `</b><br><br>
		<img src='/img/watt-level-autopilot-200.png' width='200px' height='119px' alt='Watt level'/><br><br>

		Your Mebot's Watt Level 👇<br> Your Mebot's Autopilot Level<br>
		<br>
		You can upgrade Autopilot by redeeming your ✨<br>
		You can also improve your Autopilot Level by solving puzzles and matching Sumerian characters.<br><br>
		</center>`, 7000)
	}

	function displayRechargeMebotMessage(is_game_over = false) {

		let header = '<span style="font-size: 40px;">🚫</span>';
		if (is_game_over) {
			header = '<span style="font-size: 30px;">👾 Game Over!</span>';
		}

		displayMebotMessage(`
		<br><br>
		` + header + `
		<br><br>
<span style="display: flex; align-items:center; text-align: center; justify-content: center;">
<span class="info">You have <b>0 steps left!</b><br> Recharge your Mebot by going for a walk 🏃‍♂️ and taking more steps.<br>
	    <center>
   		<table><tr><td align=center valign=middle>
    	<span style="display: flex; align-items:center; text-align: center; justify-content: center;"><img src='` + recharge_mebot_url + `' width="28px" alt="Your mebot"/> 
    	<span class="text-electric-yellow">⚡</span> 👟 </span>
    	</td></tr></table>
    	</center>
    	<br><br>`, 10000, 'Okay!')
	}

	function setSpeed() {
		_default_delay = 220 - Math.floor(speed_factor/2)
		if (_default_delay < 100) _default_delay = 100;
		if (autopilot_level > 5) {
			_default_delay = _default_delay - ( (autopilot_level-5) * 12)
			if (_default_delay < 20) _default_delay = 20;
		}
		//console.log('default delay ' + _default_delay)
		progress_factor.set(speed_factor/200)
	}

	function toggleAutopilot () {
		auto_roam = !auto_roam;
	}

	function saveAutopilot () {
		console.log('save auto: ' + auto_roam)
		setCookie("autopilot", auto_roam, 365);
	}

	function displayIntroMessage() {

		let intro_played = getCookie("intro1");
		if (intro_played != 'yes') {
			displayMebotMessage(`
			<br><br>
			<b>Welcome to Move!</b><br><br><br>
			<b>Help your Mebot explore 🧭 <br>Land42 with your steps 👟</b>
			<br><br>
			Collect &nbsp;✨ ⚡<br>
			Find Mebot egg &nbsp;🥚 <br>
			Watch out for &nbsp;🧟 <br>
			Set new high score! &nbsp;🏆

			<br><br><br>
			`, 10000, "Let's go!")
		}
		setCookie("intro1", 'yes', 7);

		if (getCookie("autopilot") != '') {
			console.log('setting auto-pilot: ' + getCookie("autopilot"))
			//auto_roam = (getCookie("autopilot") === 'true');
			auto_roam = false;
		}
	}

	async function fetchLeaderboard() {

		const res = await fetch(
			"https://api.forever.today/?method=get_move_leaderboard",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.mebots;
	}

	function setWinners() {
		mebot_winner_img_url[1] = mebots[0].img;
		mebot_winner_score[1] = mebots[0].prize_n;
		mebot_winner_id[1] = mebots[0].id;
		mebot_winner_img_url[2] = mebots[1].img;
		mebot_winner_score[2] = mebots[1].prize_n;
		mebot_winner_id[2] = mebots[1].id;
		mebot_winner_img_url[3] = mebots[2].img;
		mebot_winner_score[3] = mebots[2].prize_n;
		mebot_winner_id[3] = mebots[2].id;
		progress.set(0)
	}

	function endGameEarly() {
		progress_factor.set(0)

		if (time_remaining > 0) {
			cur_time = Math.floor(Date.now() / 1000);
			time_remaining = play_time - cur_time + start_time;
			if (time_remaining > 1) {
				play_time = cur_time - start_time;
			}
		}
		displayMebotMessage("<br><br>🛑 &nbsp;Game Over! <br><br><br>", 2000, 'Okay!')
	}

	async function fetchActiveMebots() {
		//runners
		let type_id = 10;

		const res = await fetch(
			"https://api.forever.today/?method=get_mebot_pack",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					type_id,
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.mebots;
		let cal_speed_factor = 0;
		if (json.data.daily_steps_n < minimum_steps) {
			steps_remaining = minimum_steps;
		} else {
			steps_remaining = json.data.daily_steps_n;
		}
		let game_watts = json.data.attr;

		for (const runner of runners) {
			cal_speed_factor = Math.floor(runner.watt_level * 20) ;
			cal_speed_factor = cal_speed_factor + Number(runner.watts);
			if (cal_speed_factor > 200) cal_speed_factor = 200;
			//console.log(' Mebot ' +  runner.id + ' ('+ runner.watt_level +') -> cal_speed_factor: ' + cal_speed_factor)
			mebots.push({
				id: runner.id,
				img: runner.mebot_img_url,
				is_owner: runner.is_owner,
				team_miami: (runner.is_owner == 0 ? runner.team == 'miami' : 0),
				team_nyc: (runner.is_owner == 0 ? runner.team == 'nyc' : 0),
				watts: runner.watts,
				prize_n: 0,
				steps_n: 0,
				level: runner.watt_level,
				speed_factor: cal_speed_factor
			});
			if (runner.is_owner == 1) {
				watts_count = runner.watts;
				watts_level = Number(runner.watt_level);
				if (isNaN(watts_level) || watts_level == '' || watts_level < 0) {
					watts_level = 0;
				}
				autopilot_level = watts_level;
				if (Number(runner.autopilot_level) > 0) {
					autopilot_level = runner.autopilot_level
					if (autopilot_level > 5) {
						other_m_delay = (autopilot_level-5)*20;
					}
					//console.log('!!!autopilot ' + autopilot_level)
				}
				if (auto_targets.length > 0 && auto_targets.length > autopilot_level) {
					//console.log('limiting ' + auto_targets)
					if (autopilot_level-2 <= 0) {
						auto_targets = []
					} else {
						auto_targets.slice(0, autopilot_level*2-2)
					}
					//console.log('to: ' + auto_targets)
				}

				watts_calc = Number(watts_count) + Math.floor(10 * watts_level)
				console.log('watts level: ' + watts_level + ' calc: ' + watts_calc)
				recharge_mebot_url = runner.mebot_img_url;
				speed_factor = watts_calc
				nominal_speed_factor = watts_calc
				if (speed_factor > 200) speed_factor = 200;
				setSpeed()
			}
			//console.log('mebot speed factor: ' + cal_speed_factor);
		}
		if (steps_remaining <= 0) {
			displayRechargeMebotMessage()
		}
		if (recharge_mebot_url == '') {
			displayUnhatchedMessage()
		}

		//var mask = 1 << 5; // gets the 6th bit
		var der = 1 << 1; // gets the 2nd bit
		if ((game_watts & der) != 0) {
			watts_e = true;
			// bit is set
		} else {
			// bit is not set
			watts_e = false;
		}

		let m_pos = 0;
		if (mebots_moving == true) {
			for (let i = 1; i <= _number_of_mebots; ++i) {
				if (mebots[i - 1].img != "") {

					if (i == _number_of_mebots ) {

						//place in third quadrant
						target_tile_x = Math.floor(Math.random() * 8 + 2);
						target_tile_y = Math.floor(Math.random() * (game_row_size-10) + 9);
						m_pos = target_tile_y * game_row_size + target_tile_x;
						console.log('placed ' + target_tile_x + ' mebot ' + target_tile_y + ' at: ' + m_pos)

					} else if (i >= 8) {

						//place in fourth quadrant
						target_tile_x = Math.floor(Math.random() * (game_row_size-10) + 9);
						target_tile_y = Math.floor(Math.random() * (game_row_size-10) + 9);
						m_pos = target_tile_y * game_row_size + target_tile_x;

					} else {
					m_pos = Math.floor(Math.random() * (x_offset+(game_size_active)) + x_offset + game_row_size + 1)
					row = m_pos%game_row_size_active;
					if (row < 1) row = 1;
					m_pos = row*game_row_size + Math.floor(Math.random() * 8 + 1);
					if (m_pos == (game_row_size + 1)) {
						m_pos++;
					}
					}

					if (mebots[i - 1].is_owner == 1) {
						m_pos = 1 * game_row_size + 1;
					}
					//m_pos = Math.floor(Math.random() * 200 + 17);
		
					boosts_left[i] = 0;
					mebot_pos[i] = m_pos;
					dir[i] = 2;
					update_board();
					await sleep(Math.floor(Math.random() * 100 + 1));

					if (mebots[i-1].is_owner == 1) {
						owner_id = i-1;
						if (landTiles[m_pos].s == -1) {
							sparkle_count--;
							mebots[i-1].prize_n++;
							prize_n = mebots[i-1].prize_n;
							is_sparkle_flash = true;
						}
						landTiles[m_pos].s = i;
						dirs[i] = []
					}

					mebot_walk(i);
				}
			}
		}
	}

	async function saveGame(watt_r = false) {
		is_flashing = false;
		is_sparkle_flash = false;

		//watt_r => found_egg (true)
		let mebot_stats = JSON.stringify(mebots);
		const res = await fetch(
			"https://api.forever.today/?method=save_move_game",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
					steps_taken,
					prize_n,
					mebot_stats,
					watt_r,
					bc: bolts_collected
				}),
			}
		);
	}

	let cardBackShowing = false;

	function arrayRemove(arr, value) {
		return arr.filter(function (ele) {
			return ele != value;
		});
	}

	const toggleBackFront = async (e) => {
		selected = Number(e.target.dataset.cardId)

		if (selected >= 0 && time_remaining > 0) {
			if (selected == 0) selected = 1;
			row = Math.floor(selected/game_row_size_active);
			target_tile = x_offset + (row+y_offset)*game_row_size + selected%game_row_size_active;
			//target_tile = selected + x_offset + y_offset*game_row_size;
			//console.log(target_tile)

			last_tap = current_tap;
			current_tap = selected;
			auto_assigned = false;

			if (steps_remaining <= 0) {
				displayRechargeMebotMessage()
			}
			if (speed_factor <= 0) {
				displayZombieMessage()
			}
		}
	};

	let dash_token = params.t;
	if (dash_token != '1') {
		if (getCookie("m_dash_token") != '') {
			dash_token = getCookie("m_dash_token")
		}
	}
	let dash_token_link = dash_token;
	if (dash_token_link != '1') {
		dash_token_link = '2'
	}

	let mebot_id = params.id;
	mebot_id = getCookie('m_id');
	if (mebot_id == '') {
		mebot_id = 0;
	}

	//fetchLeaderboard();
	fetchActiveMebots();
	displayIntroMessage();
	progress.set(1)
	progress_factor.set(0.5)

	function update_tile(id) {
		let pos = id;
		let x = 0;
		let y = 0;
		landTiles[id].found = 1;

		for (x = -1; x <= 1; x++) {
			for (y = -1; y <= 1; y++) {
				pos = id + x + (y*game_row_size);
				if ( pos >= 0 && pos < game_size && landTiles[pos].found == 0 ) {
					landTiles[pos].found = 1;
				}
			}
		}
	}

	function calculate_next_dir(id) {

		if (target_tile == mebot_pos[id]) {

			//dir[id] = Math.floor(Math.random() * 4 + 1);
			//dirs[id] = [dir[id]];
			dirs[id] = [];
			auto_assigned = true;
			auto_targets = auto_targets.filter(item => item !== target_tile)
			//console.log('found target ' + target_tile)
			//console.log(auto_targets)
			target_tile = 0;

		} else {

			dirs[id] = [];
			last_mebot_dir[id] = 0;

			target_tile_x = target_tile%game_row_size;
			target_tile_y = Math.floor(target_tile/game_row_size);
			owner_x = mebot_pos[id]%game_row_size;
			owner_y = Math.floor(mebot_pos[id]/game_row_size);

			//(landTiles[next_mebot_pos[id]].s <= 0)
			if (target_tile_x > owner_x) {
				dirs[id] = [...dirs[id], 2]
			}
			if (target_tile_x < owner_x) {
				dirs[id] = [...dirs[id], 1]
			}
			if (target_tile_y > owner_y) {
				dirs[id] = [...dirs[id], 4]
			}
			if (target_tile_y < owner_y) {
				dirs[id] = [...dirs[id], 3]
			}
		}

		current_tap = -1;
	}

	function calculate_pos(id, dirs_local) {

		next_mebot_pos[id] = -1;
		for (const dir of dirs_local) {

			if (next_mebot_pos[id] == -1) {
				calculated_pos[id] = mebot_pos[id];
			} else {
				calculated_pos[id] = next_mebot_pos[id];
			}

			if (dir == 1 && mebot_pos[id] > 0 && last_mebot_dir[id] != 2) {
				if (mebot_pos[id] % game_row_size != 1) {
					if (mebots[id-1].is_owner == 1 && (mebot_pos[id]%game_row_size - x_offset) <= 2 && x_offset > 0) {
						x_offset = x_offset - 2;
					}
					next_mebot_pos[id] = calculated_pos[id] - 1;
				}
			}
			if (dir == 2 && last_mebot_dir[id] != 1) {
				if (mebot_pos[id] % game_row_size < game_row_size-2 && mebot_pos[id] < game_size-1) {
					if (mebots[id-1].is_owner == 1 && (mebot_pos[id]%game_row_size - x_offset) >= 5 && x_offset < game_row_size-game_row_size_active) {
						x_offset = x_offset + 2;
					}
					next_mebot_pos[id] = calculated_pos[id] + 1;
				}
			}
			if (dir == 3 && mebot_pos[id] > game_row_size*2 && last_mebot_dir[id] != 4) {
				if (mebots[id-1].is_owner == 1 && (Math.floor(mebot_pos[id]/game_row_size) - y_offset) <= 2 && y_offset > 0) {
					y_offset = y_offset - 2;
				}
				next_mebot_pos[id] = calculated_pos[id] - game_row_size;
			}
			if (dir == 4 && mebot_pos[id] < game_size-game_row_size*2 && last_mebot_dir[id] != 3) {
				if (mebots[id-1].is_owner == 1 && (Math.floor(mebot_pos[id]/game_row_size) - y_offset) >= 5 && y_offset < game_row_size-game_row_size_active) {
					y_offset = y_offset + 2;
				}
				next_mebot_pos[id] = calculated_pos[id] + game_row_size;
			}

			if (mebots[id-1].is_owner == 1) {
				steps_took++;
			} else {
				//avoid zombies 
			}
			mebots[id-1].steps_n++;
		}
	}

	function find_prize_dir(id) {
		let pos = mebot_pos[id];
		let start_pos = mebot_pos[id];
		let x = 0;
		let y = 0;
		let tmp_dirs = [];
		let found_sparkle = 0;
		let found_tile = 0;

		for (x = -1; x <= 1; x++) {
			for (y = -1; y <= 1; y++) {
				//if ((x == 0 || y == 0) && (x != 0 || y != 0)) {
				if (x != 0 || y != 0) {
					/*if (tmp_dirs.length == 2) {
						//console.log('found corner')
						console.log(dirs)
						continue;
					}*/
					if (found_sparkle == 1) {
						//console.log(tmp_dirs)
						continue;
					}
					pos = start_pos + x + (y*game_row_size);
					if ( found_sparkle == 0 && pos >= 0 && pos < game_size && landTiles[pos].s <= -1 && landTiles[pos].s >= -3 ) {
						found_sparkle = 1;
						if (x == 1 && !tmp_dirs.includes(2)) { tmp_dirs = [...tmp_dirs, 2] }
						if (x == -1 && !tmp_dirs.includes(1)) { tmp_dirs = [...tmp_dirs, 1] }
						if (y == 1 && !tmp_dirs.includes(4)) { tmp_dirs = [...tmp_dirs, 4] }
						if (y == -1 && !tmp_dirs.includes(3)) { tmp_dirs = [...tmp_dirs, 3] }
					}
					//if ( found_sparkle == 0 && pos >= 0 && pos < game_size && landTiles[pos].found == 0) {
					//	tmp_dirs = [];
					//	if (x == 1 && !tmp_dirs.includes(2)) { tmp_dirs = [...tmp_dirs, 2] }
					//	if (x == -1 && !tmp_dirs.includes(1)) { tmp_dirs = [...tmp_dirs, 1] }
					//	if (y == 1 && !tmp_dirs.includes(4)) { tmp_dirs = [...tmp_dirs, 4] }
					//	if (y == -1 && !tmp_dirs.includes(3)) { tmp_dirs = [...tmp_dirs, 3] }
					//	found_tile = 1;
					//	console.log('found file')
					//}
					//if not found try combing corners 
				}
			}
		}

		if (found_sparkle == 1 || found_tile == 1) dirs[id] = tmp_dirs;
	}

	async function mebot_walk(id) {

		if (mebots[id-1].is_owner == 1) {
			is_flashing = false;
			is_sparkle_flash = false;
		}

		last_mebot_pos[id] = mebot_pos[id];
		next_mebot_pos[id] = -1;
		if (mebots[id-1].is_owner == 1) {
			steps_took = 0;
			if (zombie_eaten > 0) zombie_eaten--;
		}
		//choose next direction

		if (landTiles[mebot_pos[id]].s == -1) {
			sparkle_count--;
			mebots[id-1].prize_n++;
			if (mebots[id-1].is_owner == 1) {

				prize_n = mebots[i-1].prize_n;
				is_sparkle_flash = true;
			}
		}

		//if (mebots[id-1].is_owner != 1 || isNaN(dirs[id])) {
			dirs[id] = [];
		//}
		dir[id] = Math.floor(Math.random() * 4 + 1);
		if (auto_roam == true || mebots[id-1].is_owner != 1) {
			dirs[id] = [dir[id]];
		}
		if (mebots[id-1].is_owner == 1 && target_tile == 0 && auto_roam) {
			if (auto_targets.length > 0) {
				target_tile = auto_targets[0]
				//console.log('NEW1 searching for:' + target_tile)
				//console.log(auto_targets)
				auto_assigned = true;
			} else {

				//find sparkle since everything else taken
				let found = -1;
				for (let i = 0; i < game_size; i++) {
					if (landTiles[i].s == -1)
						found = i;
				}
				if (found != -1 && autopilot_level > 3) {
					//console.log('found! ' + found)
					auto_targets = [found]
				}
			}
		}
		if (mebots[id-1].is_owner == 1 && target_tile > 0 && auto_roam && auto_assigned == true && !auto_targets.includes(target_tile)) {
			target_tile = 0;
			if (auto_targets.length > 0) {
				target_tile = auto_targets[0]
				//console.log('NEW2 searching for:' + target_tile)
				//console.log(auto_targets)
				auto_assigned = true;
			}
		}
		if (mebots[id-1].is_owner == 1 && target_tile > 0) {
			//console.log('searching for:' + target_tile)
			//owner only
			calculate_next_dir(id);
		}
		if (auto_roam == true || mebots[id-1].is_owner != 1) {
			//sniff out prizes
			find_prize_dir(id);
		}

		if (steps_remaining > 0 || mebots[id-1].is_owner != 1) {
			if (mebots[id-1].is_owner == 1) {
				//console.log('checking next pos: ' + dirs[id])
			}
			calculate_pos(id, dirs[id])
			//check single directions if the two directions are not working
			if (mebots[id-1].is_owner == 1 && dirs[id].length == 2 && next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s > 0 || landTiles[next_mebot_pos[id]].s <= -4)) {
				//console.log('checking single pos: ' + dirs[id][0])
				calculate_pos(id, [dirs[id][0]])
			}
			if (mebots[id-1].is_owner == 1 && dirs[id].length == 2 && next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s > 0 || landTiles[next_mebot_pos[id]].s <= -4)) {
				//console.log('checking single pos: ' + dirs[id][1])
				calculate_pos(id, [dirs[id][1]])
			}
			if (mebots[id-1].is_owner == 1 && next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s > 0 || landTiles[next_mebot_pos[id]].s <= -4)) {
				console.log('cannot move!')
				//if autopilot >= 5 try alternate paths
				if (dirs[id].length == 1 && autopilot_level >= 5) {
					let next_dirr = dirs[id][0];
					let tmp_dirrs = dirs[id];
					let ic = 0;
					while (ic < 4 && next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s > 0 || landTiles[next_mebot_pos[id]].s <= -4)) {
						tmp_dirrs = dirs[id];
						next_dirr++;
						ic++;
						if (next_dirr > 4) {
							next_dirr = 1;
						}
						tmp_dirrs = [...tmp_dirrs, next_dirr]
						console.log('trying different ' + ic + '  dir: ' + tmp_dirrs)
						calculate_pos(id, tmp_dirrs)
					}
				}
			}
		}

		//if (dir[id] == 5) {
		//}

		//check if tile is empty
		//if (last_mebot_pos[id] != mebot_pos[id] && landTiles[mebot_pos[id]].s == 0) {
		//if (last_mebot_pos[id] != mebot_pos[id]) {
		//if (next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s <= 0 || mebots[id-1].is_owner == 1)) {

		//avoid zombies  if (Math.floor(Math.random() * 60 + 1) == 2) {
//		if (mebots[id-1].is_owner != 1 && next_mebot_pos[id] >= 0 && landTiles[next_mebot_pos[id]].s == -4) {
		if (next_mebot_pos[id] >= 0 && landTiles[next_mebot_pos[id]].s == -4 && (mebots[id-1].is_owner != 1 || Math.floor(Math.random() * 4 + 1) > (5 - autopilot_level) && auto_roam)) {
			next_mebot_pos[id] = -1;
		}

		if (next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s <= 0)) {
			if (landTiles[next_mebot_pos[id]].s == -1) {
				sparkle_count--;
				mebots[id-1].prize_n++;
				if (mebots[id-1].is_owner == 1 && speed_factor > 0) {
					prize_n = mebots[id-1].prize_n
					is_sparkle_flash = true;

					if (steps_remaining > 0 && speed_factor > 0) {
						progress_n += 25;
						if (progress_n > 100) progress_n = 100;
						progress.set(progress_n/100)
					}

					//audio.play();
				}
			}
			if (landTiles[next_mebot_pos[id]].s == -2) {
				if (mebots[id-1].is_owner == 1) {
					speed_factor = speed_factor + 7;

					if (steps_remaining > 0 && speed_factor > 0) {
						progress_n += 35;
						if (progress_n > 100) progress_n = 100;
						progress.set(progress_n/100)
					}

					if (speed_factor > 200) speed_factor = 200;
					is_flashing = true;

					setSpeed()
					bolts_collected++;
					//boost_left = 140;
					//delay = 100;


					//boost_audio.play();
				} else {
					boosts_left[id] = 140;
				}
			}
			if (landTiles[next_mebot_pos[id]].s == -3) {
				if (mebots[id-1].is_owner == 1) {
					play_time = play_time + 15;
					extra_time = Math.floor(Date.now() / 1000);
				}
			}
			if (mebots[id-1].is_owner == 1 && speed_factor > 0) {

				if (landTiles[next_mebot_pos[id]].s == -4) {
				speed_factor = speed_factor - 30;
				zombie_eaten = 2;

				progress_n = progress_n - Math.floor( progress_n * .3 )
				progress.set(progress_n/100)

				is_flashing = true;
				setSpeed();
				if (speed_factor < 0) { 
					displayZombieMessage()
					landTiles[last_mebot_pos[id]].s = 0;
					landTiles[next_mebot_pos[id]].s = id;
					speed_factor = 0;
					update_tile(next_mebot_pos[id]);

					cur_time = Math.floor(Date.now() / 1000);
					time_remaining = play_time - cur_time + start_time;
					if (time_remaining > 3) {
						play_time = 3 + cur_time - start_time;
					}
					progress.set(0)
				}
				}

				if (landTiles[next_mebot_pos[id]].s == -6) {
					displayFoundEgg()
					landTiles[last_mebot_pos[id]].s = 0;
					landTiles[next_mebot_pos[id]].s = id;
					cur_time = Math.floor(Date.now() / 1000);
					time_remaining = play_time - cur_time + start_time;
					if (time_remaining > 1) {
						play_time = 1 + cur_time - start_time;
					}
				}
			}
			if (steps_remaining > 0 && speed_factor > 0 && mebots[id-1].is_owner == 1) {
				steps_took = steps_took;
				steps_remaining = steps_remaining - steps_took;
				if (steps_remaining < 0) steps_remaining = 0;
				steps_taken += steps_took
				if (steps_remaining == 0) {

					cur_time = Math.floor(Date.now() / 1000);
					time_remaining = play_time - cur_time + start_time;
					if (time_remaining > 5) {
						play_time = 5 + cur_time - start_time;
					}
					progress.set(0)
					displayRechargeMebotMessage(true)
					//if (time_remaining > 7) {
					//	time_remaining = 7;
					//}
					saveGame()
				}
			}
			if ((steps_remaining > 0 && speed_factor > 0) || mebots[id-1].is_owner != 1) {
				if (mebots[id-1].is_owner != 1 && landTiles[next_mebot_pos[id]].s > -5
				  || mebots[id-1].is_owner == 1 && landTiles[next_mebot_pos[id]].s != -5) {
				landTiles[last_mebot_pos[id]].s = 0;
				landTiles[next_mebot_pos[id]].s = id;
				mebot_pos[id] = next_mebot_pos[id];
				last_mebot_dir[id] = dir[id];
				auto_targets = auto_targets.filter(item => item !== next_mebot_pos[id])
				update_tile(next_mebot_pos[id]);
				}
			}
		}
		last_mebot_dir[id] = dir[id];

		//{
		//	mebot_pos[id] = last_mebot_pos[id];
		//}

		//await sleep(Math.floor(Math.random() * 600 + 100));
		if (id > 0 && mebots[id - 1].is_owner == 1) {
			//delay = 300;
			//console.log(delay)
			//await sleep(Math.floor(Math.random() * delay + (delay-50)));
			if (boost_left > 0) {
				boost_left--;
			}
			if (boost_left == 0) {
				delay = _default_delay
			}
			await sleep(delay);
		} else {
			//if (false) {
			if (boosts_left[id] > 0) {
				boosts_left[id]--;
				await sleep(100 + other_m_delay);
			} else {
				//await sleep(Math.floor(Math.random() * 1000 + 500));
				//console.log('delay ' + mebots[id - 1].watts)
				//Math.floor(Math.random() * (max - min + 1)) + min;
				//min: 300 -  mebots[id - 1].speed_factor
				//max: 600 -  mebots[id - 1].speed_factor
				//await Math.floor(Math.random() * (600 -  mebots[id - 1].speed_factor - 300 -  mebots[id - 1].speed_factor + 1)) + 300 -  mebots[id - 1].speed_factor;
				await sleep(Math.floor(Math.random() * (700-mebots[id - 1].speed_factor) + 300 - mebots[id - 1].speed_factor) + other_m_delay);
				//console.log(Math.floor(Math.random() * (700-mebots[id - 1].speed_factor) + 300 - mebots[id - 1].speed_factor))
				//console.log((700-mebots[id - 1].speed_factor))
			}
		}

		update_board()
		if (time_remaining <= 0) {
			current_tap = -1;

			if (mebots[id-1].is_owner == 1) {
				//if Zombies got our mebot remove his prizes
				if (speed_factor <= 0) {
					mebots[id-1].prize_n = -1;
					//prize_n = 0;
				}
				mebots.sort((a, b) => b.prize_n - a.prize_n);
				await saveGame();
				await sleep(310);
				setWinners();
			}
			return;
		}
		//landTilesFinal = landTiles.slice(x_offset, x_offset + game_size_active);
		if (mebots[id-1].is_owner == 1) {
			cur_time = Math.floor(Date.now() / 1000);
			time_remaining = play_time - cur_time + start_time;
			if (time_remaining > play_time) time_remaining = play_time;
			if (time_remaining < 0) time_remaining = 0;
			//console.log(cur_time);

			if (time_remaining > 0 && speed_factor > 0) {
				progress_n = progress_n - Math.floor( progress_n * .08 )
				if (progress_n < 0) progress_n = 0;
				progress.set(progress_n/100)
			}

			if ((Date.now()%10 == 0) && speed_factor > watts_calc) {
				speed_factor = speed_factor - Math.floor(speed_factor * .02)
				if (speed_factor < watts_calc) {
					speed_factor = watts_calc;
				}
			}
		}

		if (mebots[id-1].is_owner == 1 && sparkle_count <= 0) {
			await reloadBoard();
			update_tile(mebot_pos[owner_id+1])
		}
		mebot_walk(id);
	}

	onMount(async () => {
		//console.log("mount");
		//return () => console.log("unmount"); // not called
	});
	onDestroy(() => {
		//console.log("test");
	});

	function zeroPad(num, places) {
		var zero = places - num.toString().length + 1;
  		return Array(+(zero > 0 && zero)).join("0") + num;
	}

	function numberWithCommas(x) {
    	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	let charged = Math.random() * 0.0025 + 0.0005;
	charged = 0.0008;
	const SPRING_IN = { stiffness: charged, damping: 0.014 };
	const animateIn1 = (node) => {
		const { duration, tickToValue } = springIn(-9, 0, SPRING_IN);
		return {
			duration: 1000,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};
	const animateIn2 = (node) => {
		const { duration, tickToValue } = springIn(-8, 0, { stiffness: charged, damping: 0.014 });
		return {
			duration: 1200,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};
	const animateIn3 = (node) => {
		const { duration, tickToValue } = springIn(-8, 0, { stiffness: charged, damping: 0.014 });
		return {
			duration: 800,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

</script>

<Header header_mebot_id={mebot_id} header_dash_token={dash_token} />

<br />
<center>
<div class="small_row">
	<table width=300px border=0 cellspacing=0>
	<tr>
	<td width=110px valign=middle style="white-space:nowrap;">
	<span>
		<table border=0 width=120px cellspacing=0> <tr><td align=left>
		<span class="text-electric info" class:info-pulsing={ time_remaining > 0 && time_remaining <= 10 }>
			{Math.floor(time_remaining/60) < 10 ? '0' : ''}{ Math.floor(time_remaining/60) }:{ time_remaining < 10 ? '0' + time_remaining : (time_remaining > 59 ? ( (time_remaining % 60) < 10 ? '0' + (time_remaining % 60) : (time_remaining % 60)) : time_remaining) }
		</span>
		{#if (play_time > original_play_time && time_remaining > 0 && extra_time > cur_time-1) }
		&nbsp;<span class="text-electric-white info-time-pulsin" > ⏳</span>
		{:else if (boost_left > 0 && time_remaining > 0) }
		&nbsp;&nbsp;<span class="text-electric-white info-extra info-time-pulsing" style="white-space: nowrap;">⚡ boosted!</span>
		{:else}
		&nbsp;<span on:click={endGameEarly} class="text-electric-whit info-time-pulsin" > 🛑</span>
		{/if}

		</td><td align=right>
		<span class="text-electric"> ⚡ {bolts_collected} </span>
		</td></tr></table>
	</span>
	</td>
	<td width=120px align=left>
	<span class="stes" >
		<span style="display: flex; align-items:center; text-align: center; justify-content: center;"> {#if (recharge_mebot_url != '' && speed_factor > 0) } <img src={recharge_mebot_url} width="21px" style="margin-right: 2px;" alt="Your mebot"/> {:else if (speed_factor <= 0) } 💀&nbsp; {/if}
		<span class="text-electric-white" class:flash={ is_sparkle_flash == true } style="margin-right: 0px;">{ (owner_id == -1 || isNaN(mebots[owner_id].prize_n)) ? '0' : (prize_n) }</span>
		<span class="text-electric-white" style="display: flex; align-items:center; text-align: center; justify-content: center;"><img src='/img/sparkle-zm1.png' width=24px; alt=''></span>
		<span style="width:10px;" >{ sparkle_count }</span>
	</span>
	</td>
	<td width=70px>
	<span class="steps" on:click={displayStepsInfo}>
		<span>👟</span> <span class="text-electric">{ numberWithCommas(steps_remaining) }</span> 
	</span>
	</td>
	</tr>
	<tr>
		<td width=110px valign=middle></td>
		<td width=120px align=right>
			<table width=90px border=0 cellspacing=0><tr><td>
			<div class="outer"><div class="progress_inner" style="width: {$progress * 100}%"></div></div>
			</td></tr></table>
		</td>
		<td width=70px valign=middle></td>
	</tr>
	</table>
</div>
</center>
<center>
	<!--<a href="/#/supersnake/{dash_token}/{mebot_id}">-->
	{#if (time_remaining > 0 && is_rebuilding == 0) }

		<div class="snake_row" out:fade|local={{duration: 300}} in:fade|local={{duration: 300}} style="user-select: none; ">
			{#each landTilesFinal as { name, watt_level, watts, img, text, s, found, b}, i}
				<div class="flip-box"  style="user-select: none;">
					<div class="flip-box-inner"  style="user-select: none; ">
						<div class="flip-box-front card { b > 0 ? flip_box_border : '' } { found == 0 ? flip_box_front : '' }"
							 class:card-active={(s > 0 ? mebots[s-1].is_owner == 1 : 0) || i == current_tap}
							 class:card-active-pulse={(s > 0 ? (mebots[s-1].is_owner == 1 && auto_roam) : 0)}
							 class:card-miami={(s > 0 ? (mebots[s-1].team_miami == 1) : 0)}
							 class:card-nyc={(s > 0 ? (mebots[s-1].team_nyc == 1) : 0)}
							 class:flip-box-found={found > 0 ? 1 : 0}
							 class:text-electric-wormhole1={ found > 0 && (s == -5 || s == -6) } >
							<div
								class="vertical-center"
								on:click={toggleBackFront}>
								<!-- use:longpress on:longpress={toggleBackFront} -->
							{#if s > 0 && mebots[s-1].is_owner == 1 && (speed_factor > 0 || zombie_eaten > 0)}
							<div
								class="message question " 
								transition:fade|local={{
								duration: 300,
							}}
							>
								<img
									class:info-pulsing={ (s > 0 && mebots[s-1].is_owner == 1 && boost_left <= 0) }
									class:info-pulsing-zombie={ (s > 0 && mebots[s-1].is_owner == 1 && zombie_eaten > 0) }
									src={mebots[s-1].img}
									width="36px"
									alt="mebot"
									data-card-id={i}
								/>
							</div>
							<!--<div class="message question " data-card-id={i} > <img src="{mebots[s-1].img}" width=36px alt="mebot"></div>-->
							{/if}
								{#if s > 0 && mebots[s-1].is_owner == 0}
									<div class="message question card-other-mebot-active">
										<img
											src={mebots[s-1].img}
											width="36px"
											alt="mebot"
											data-card-id={i}
										/>
									</div>
									<!--<div class="message question " data-card-id={i} > <img src="{mebots[s-1].img}" width=36px alt="mebot"></div>-->
								{/if}
								{#if s == 0 || s == -1 && found == 0}
								<div data-card-id={i} style="width: 40px; height: 40px;"> </div>
								{/if}
								{#if s == -1 && found > 0}
<!--								<div ><img data-card-id={i} src={large_sparkle_img} width=32px alt="mebot"></div>-->
<!--									<div style="width: 30px; height: 30px;"> <div data-card-id={i} class="vertical-center1 text-electric-white" style="display: block; width: 30px; height: 30px;">✨</div> </div>-->
									<div style="width: 40px; height: 40px;"> <span class="text-electric-white"><img data-card-id={i}  src={sparkle_img} width=40px; alt=''></span> </div>
<!--
{#if i < 10 || i > 24 }
<div style="width: 40px; height: 40px;"> <span class="text-electric-white"><img data-card-id={i}  src={sparkle_img} width=40px; alt=''></span> </div>
{:else}
<div style="width: 40px; height: 40px;"> <span class="text-electric-white"><img data-card-id={i}  src='https://mebots.xyz/img/land42_{i}_500.png' width=40px; style="border-radius: 5px;" alt=''></span> </div>
{/if}-->										
								{/if}
								{#if s == -2 && found > 0}
								<div style="width: 40px; height: 40px;"> <span data-card-id={i} class="vertical-center2 text-electric-yellow-bolt" style="display: block; width: 40px; height: 40px; ">⚡</span> </div>
								{/if}
								{#if s == -3 && found > 0}
								<div style="width: 40px; height: 40px;"> <span data-card-id={i} class="vertical-center2 text-electric-white-clock" style="display: block; width: 40px; height: 40px; ">⌛</span> </div>
								{/if}
								{#if s == -4 && found > 0}
								<div style="width: 22px; height: 22px;"> <span data-card-id={i} class="vertical-center1 text-electric-zombie" style="width: 20px; height: 20px; ">🧟</span> </div>
								{/if}
								{#if s == -5 && found > 0}
								<div style="width: 40px; height: 40px; display: block;" > <span data-card-id={i} class="vertical-center1" style=" display: block; width: 20px; height: 20px; "><!--🌌--></span> </div>
								{/if}
								{#if s == -6 && found > 0}
								<div style="width: 22px; height: 22px;"> <span data-card-id={i} class="vertical-center1 text-electric-egg" style="width: 20px; height: 20px; ">🥚</span> </div>
								{/if}

							</div>
						</div>
					</div>
				</div>
			{/each}
		</div>

		<center>
			<div class="small_row">
			<table width=300px>
				<tr height=20px>
					<td width=150px valign=middle>
						<span on:click={displaySpeedFactorInfo} class="text-electric info" style="white-space: nowrap;" >
							Speed factor 💨  <span class:flash={ is_flashing == true }><span class="text-electric-yellow"></span> <span class:text-electric-red={ speed_factor <= 30 }> { (speed_factor <= 0 ? '💀' : speed_factor) } </span> </span>
						</span>
					</td>
					<td width=110px align=right> 
						<div style="height:1px;"></div>
						<span on:click={displayAutopilot} class="text-electric info" style="white-space: nowrap;" >Autopilot: {autopilot_level}&nbsp;</span>
					</td>
					<td width=40px valign=middle align=left>
						<div style="height:2px;"></div>
						<span class="text-electric info" style="white-space: nowrap;" >
							<Switch bind:checked={auto_roam}></Switch>
						</span>
					</td>
				</tr>

				<tr>
					<td width=150px valign=top>
						<span class="outer"><span class="speed_factor_progress_inner" style="width: {$progress_factor * 100}%"></span></span>
					</td>
					<td width=110px >&nbsp;</td>
					<td width=40px valign=middle></td>
				</tr>
			</table>
			</div>
		</center>

	{:else if (time_remaining <= 0 && mebot_winner_img_url.length >= 3) }
	<!--</a>-->
	<br>
	<center>
		<div class="small_row">
			<table width=300px><tr>
			<td width=150px align=left>
				<button class="menu_btn_home">
					<span class="leaderboard" >
						&nbsp; <span class="text-electric"> Results </span> &nbsp;
					</span>
				</button>
			</td>
			<td width=150px align=right>
				<a href="/#/move_leaderboard/{dash_token_link}/{mebot_id}/1">
					<button class="menu_btn_home">
					<span class="leaderboard" >
						&nbsp;<span class="text-electric-yello">🏆</span> &nbsp; <span class="text-electri"> Leaderboard </span> &nbsp;
					</span>
					</button>
				</a>
			</td>
			</tr></table>
		</div>
	</center>
	<br>
	<center>
		<div class="snake_row" style="user-select: none; align-items: flex-end;" >
			<div in:fade|local={{duration: 450}}>
				<img on:click={ () => push('/stats/' + dash_token_link + '/' + mebot_id + '/' + mebot_winner_id[2]) } in:animateIn2|local
					src={mebot_winner_img_url[2]}
					width="85px"
					alt="meebot"
					style="user-select: none;"
				/>
				<br><br>
				<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow" style="font-size:0;"><img src='/img/sparkle-zm1.png' width=20px; alt=''><img src='/img/sparkle-zm1.png' width=20px; alt=''></span></span><br>
				<span class="text-electric-white">{mebot_winner_score[2]}</span>
			</div>
			<div in:fade|local={{duration: 300}}>
					<a href="/#/stats/{dash_token_link}/{mebot_id}/{mebot_winner_id[1]}">
					<img in:animateIn1|local
						src={mebot_winner_img_url[1]}
						width="170px"
						alt="meebot"
						style="user-select: none;"
					/>
					</a>
					<br>
					<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow" style="font-size:0;"><img src='/img/sparkle-zm1.png' width=20px; alt=''><img src='/img/sparkle-zm1.png' width=20px; alt=''><img src='/img/sparkle-zm1.png' width=20px; alt=''></span></span><br>
					<span class="text-electric-white">{mebot_winner_score[1]}</span>
				</div>
			<div in:fade|local={{duration: 600}}>
				<a href="/#/stats/{dash_token_link}/{mebot_id}/{mebot_winner_id[3]}">
				<img in:animateIn3|local
					src={mebot_winner_img_url[3]}
					width="85px"
					alt="meebot"
					style="user-select: none; align-items: flex-end;"
				/>
				</a>
				<br><br>
				<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"><img src='/img/sparkle-zm1.png' width=20px; alt=''></span></span><br>
				<span class="text-electric-white" style="margin-top: 10px;">{mebot_winner_score[3]}</span>
			</div>
		</div>
		<br>
	</center>

		<span on:click={restartGame} class="vitals_bold text-electric" style="font-size: 50px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">&#8634;</span>
	{/if}
</center>

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}>
</Modal>

<style>

	.text-electric {
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px hsla(178, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}

	.text-electric-red {
		text-shadow: 0 0 32px rgba(255, 192, 192, 0.9),
			0 0 32px hsla(0, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(0, 98%, 66%);
	}

	.question {
		color: white;
		font-size: 18px;
		text-shadow: 0 0 40px rgba(195, 195, 195, 0.9),
			0 0 32px rgba(255, 255, 255, 0.98);
		font-family: arial;
	}

	.snake_row {
		display: flex;
		flex-wrap: wrap;
		width: 350px;
		justify-content: center;
		margin-bottom: 10px;
		background-size: contain;
		overscroll-behavior: none;
/*		background-image: url("/img/imageedit_1_613383927.png");*/
	}

	.snake_col {
		display: flex;
		flex-wrap: wrap;
		width: 350px;
		height: 350px;
		justify-content: center;
		margin-bottom: 10px;
		background-size: contain;
/*		background-image: url("/img/imageedit_1_613383927.png");*/
	}

	/* The flip box container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
	.flip-box {
		background-color: transparent;
		width: 34px;
		height: 34px;
		margin: 0 2px 4px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}

	/* This container is needed to position the front and back side */
	.flip-box-inner {
		position: relative;
		width: 100%;
		height: 100%;
		text-align: center;
		transition: transform 0.8s;
		transform-style: preserve-3d;
	}

	/* Position the front and back side */
	.flip-box-front,
	.flip-box-back {
		position: absolute;
		width: 100%;
		height: 100%;
		-webkit-backface-visibility: hidden; /* Safari */
		backface-visibility: hidden;
	}

	/* Style the front side */
	.flip-box-front1 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		background-color: rgba(192, 212, 255, 0.1)
	}
	.flip-box-front2 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		background-color: rgba(255, 192, 252, 0.1)
	}
	.flip-box-front3 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		background-color: rgba(255, 230, 192, 0.279)
	}
	.flip-box-front4 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		background-color: rgba(192, 204, 255, 0.44)
	}

	.flip-box-found {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		/*background-color: #57d5f1;*/
		background-color: #0d1f23;
	}
	.flip-box-found1 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		/*background-color: #57d5f1;*/
		background-color: #200d23;
	}

	.flip_box_border1 {
		background-color: rgba(27, 255, 232, 0.678);
/*		background-color: rgba(25, 227, 227, 0.678)*/
	}
	.flip_box_border2 {
		background-color: rgba(252, 51, 255, 0.678);
	}
	.flip_box_border3 {
		background-color: rgba(255, 156, 27, 0.915);
	}
	.flip_box_border4 {
		background-color: rgba(27, 69, 255, 0.758);
	}

	.vertical-center {
		margin: 0;
		position: absolute;
		top: 56%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.vertical-center1 {
		margin: 0;
		position: absolute;
		top: 30%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.vertical-center2 {
		margin: 0;
		position: absolute;
		top: 70%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.text-electric-yellow {
		text-shadow: 0 0 5px rgba(255, 229, 61, 0.9),
			0 0 8px rgba(255, 239, 65, 0.98);
		font-family: arial;
		color: hsl(61, 97%, 75%);
	}
	.text-electric-yellow-bolt {
		text-shadow: 0 0 5px rgba(255, 229, 61, 0.9),
			0 0 20px rgba(255, 239, 65, 0.98);
		font-family: arial;
		color: hsl(61, 97%, 75%);
	}
	.text-electric-white {
		text-shadow: 0 0 5px rgba(253, 253, 253, 0.9),
			0 0 8px rgba(252, 252, 252, 0.98);
		font-family: arial;
		color: hsl(60, 19%, 88%);
	}
	.text-electric-white-clock {
		text-shadow: 0 0 5px rgba(253, 253, 253, 0.9),
			0 0 20px rgba(252, 252, 252, 0.98);
		font-family: arial;
		color: hsl(60, 19%, 88%);
	}
	.text-electric-zombie {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(5, 255, 130, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
		animation: zombie-pulse 1.4s infinite;
	}
	.text-electric-egg {
		text-shadow: 0 0 5px rgba(255, 255, 192, 0.7),
			0 0 10px rgba(251, 255, 29, 0.968);
		font-family: arial;
		color: hsl(70, 97%, 75%);
		animation: egg-pulse 3.5s infinite;
	}

	@keyframes egg-pulse {
	0% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(255, 251, 5, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}

	10% {
		text-shadow: 0 0 32px rgba(249, 192, 255, 0.9),
			0 0 15px rgba(201, 65, 255, 0.98);
		color: hsl(294, 97%, 75%);
	}

	100% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(251, 255, 5, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}
	}

	.text-electric-wormhole {
		text-shadow: 0 0 5px rgba(239, 192, 255, 0.7),
			0 0 10px rgba(255, 29, 191, 0.7);
		font-family: arial;
		color: hsl(295, 97%, 75%);
		animation: zombie-wormhole 2.5s infinite;
		background-color: rgba(252, 51, 255, 0.678);
	}
	@keyframes zombie-pulse {
	0% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(5, 255, 130, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}

	10% {
		text-shadow: 0 0 32px rgba(255, 248, 192, 0.9),
			0 0 15px rgba(249, 255, 65, 0.98);
		color: hsl(189, 97%, 75%);
	}

	100% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(5, 255, 130, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}
	}

	@keyframes zombie-wormhole {
	0% {
		text-shadow: 0 0 5px rgba(239, 192, 255, 0.7),
			0 0 10px rgba(255, 29, 191, 0.7);
		font-family: arial;
		color: hsl(295, 97%, 75%);
		background-color: rgba(252, 51, 255, 0.678);
	}

	10% {
		text-shadow: 0 0 5px rgba(239, 192, 255, 0.7),
			0 0 10px rgba(3, 158, 247, 0.7);
		font-family: arial;
		color: hsl(295, 97%, 75%);
		background-color: rgba(51, 228, 255, 0.959);
	}

	100% {
		text-shadow: 0 0 5px rgba(239, 192, 255, 0.7),
			0 0 10px rgba(255, 29, 191, 0.7);
		font-family: arial;
		color: hsl(295, 97%, 75%);
		background-color: rgba(252, 51, 255, 0.678);
	}
	}

.text-electric-wormhole1 {
    background: linear-gradient(129deg, #725cd8, #ff8300, #090033, #ff0000);
    background-size: 800% 800%;

    -webkit-animation: AnimationName 1.8s ease infinite;
    -moz-animation: AnimationName 1.8s ease infinite;
    -o-animation: AnimationName 1.8s ease infinite;
    animation: AnimationName 1.8s ease infinite;
}

.text-electric-wormhole2 {
    background: linear-gradient(129deg, #725cd8, #ff8300, #090033, #ff0000);
    background-size: 800% 800%;

    -webkit-animation: AnimationName 1.8s ease infinite;
    -moz-animation: AnimationName 1.8s ease infinite;
    -o-animation: AnimationName 1.8s ease infinite;
    animation: AnimationName 1.8s ease infinite;
}

@-webkit-keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
}
@-moz-keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
}
@-o-keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
}
@keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
}

	.message {
		margin: 0;
		position: absolute;
		top: 50%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	img {
		max-height: 90%;
	}

	.card {
		border-radius: 4px;
		color: rgb(216, 79, 0);
		box-shadow: 0 4px 8px 0 rgba(189, 140, 104, 0.2);
	}

	.card-miami {
		background-color: rgba(163, 65, 255, 0.59);
	}
	.card-nyc {
		background-color: rgba(254, 186, 61, 0.685);
	}

	.card-active {
		border-radius: 4px;
		color: rgb(5, 20, 32);
		background-color: rgba(65, 255, 249, 0.682);
		box-shadow: 0 0px 8px 0 rgb(173, 166, 161);
	}
	.card-active-pulse {
		background-color: rgba(65, 255, 249, 0.831);
	}
	@keyframes pulse-active {
	0% {
		background-color: rgba(65, 255, 249, 0.69);
	}

	10% {
		background-color: rgba(65, 255, 249, 0.442);
	}

	100% {
		background-color: rgba(36, 255, 200, 0.69);
	}
	}

	.card-other-mebot-active{
		opacity: .9;
	}

	.small_row {
        width: 300px;
		margin-bottom: 10px;
		margin-left: 32px;
		margin-right: 36px;
	}
	.info {
		font-size: 16px;
		justify-content: left;
	}
	.info-extra {
		font-size: 10px;
		justify-content: left;
	}

	.small_row .steps {
		color:rgba(195, 195, 195, 0.643);
        float: right;
		white-space: nowrap;
    }

	.info-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: pulse 1s infinite;
	}

	@keyframes pulse {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.2);
		text-shadow: 0 0 32px rgba(255, 248, 192, 0.9),
		0 0 32px rgba(249, 255, 65, 0.98);
		color: hsl(53, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.info-pulsing-zombie {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.1s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}


	.info-time-pulsing {
		transform: scale(1);
		animation: time-pulse 1s infinite;
	}

	@keyframes time-pulse {
	0% {
		text-shadow: 0 0 32px rgba(241, 253, 254, 0.9),
			0 0 32px rgba(234, 254, 254, 0.98);
		color: hsl(187, 100%, 98%);
	}

	10% {
		text-shadow: 0 0 32px rgba(255, 248, 192, 0.9),
			0 0 32px rgba(249, 255, 65, 0.98);
		color: hsl(53, 97%, 75%);
	}

	100% {
		text-shadow: 0 0 32px rgba(242, 254, 254, 0.9),
			0 0 32px rgba(230, 238, 237, 0.98);
		color: hsl(180, 19%, 95%);
	}
	}

	body {
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.flash {
		font-weight: bold;
		transform: scale(1);
		animation: flash-pulse 0.4s infinite;
	}

	@keyframes flash-pulse {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.2);
		text-shadow: 0 0 32px rgba(255, 248, 192, 0.9),
			0 0 32px rgba(249, 249, 249, 0.98);
		color: hsl(0, 0%, 100%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.menu_btn_home {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 3px 4px 6px 4px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}
	.leaderboard {
		font-size: 12px;
	}

	progress {
		height: 2px;
		display: block;
		width: 100%;
		border: 1px;
	}

	.progress_inner, .speed_factor_progress_inner, .outer {
		height: 2px;
		border-radius: 0px;
	}

	.progress_inner {
		background-color: #725cd8;
		display: block;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
	}

	.outer {
		margin: 0px;
		background-color: transparent;
		border: 0px;
	}

	.speed_factor_progress_inner {
		background-color: rgba(27, 255, 232, 0.847);
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
		display: block;
	}
</style>
